export function setfinancialtitle(state, payload) {
  state.financialtitle = payload;
}
